import { defaultThemeColor, themeColors } from './default-theme';

export class ProjectThemeData {

    private readonly projectColor: string;
    private readonly defaultThemeColor: string;

    constructor(projectColor: string) {
        this.projectColor = projectColor;
        this.defaultThemeColor = defaultThemeColor;
    }

    public getColor() {

        if (this.projectColor === undefined || this.projectColor === null || this.projectColor === '' || !themeColors.includes(this.projectColor)) {
            return this.defaultThemeColor;
        }

        return this.projectColor.toLowerCase();
    }
}

